import { menuRegistry } from '@/common/menu/menuRegistry';
import { registerRouteForModule } from '@/common/route/registerModules';
import router, { ROUTE_NAME_CHALLENGE } from './router';

menuRegistry.registerMenu([
    {
        parent: 'Multiplayer',
        key: 'Challenge',
        name: 'Challenge',
        icon: 'fas fa-gamepad',
        route: { name: ROUTE_NAME_CHALLENGE.INDEX }
    }
]);

export default registerRouteForModule(router);
